import { axiosToken } from 'api/apiBase/axios';
import { IBaseResponse } from 'api/apiBase/IBaseResponse';
import { mapError } from 'api/apiBase/mapError';
import { mapResponse } from 'api/apiBase/mapResponse';
import { Response } from 'api/apiBase/Response';
import { ENetwork } from 'web3';

import { IGasPriceResponse } from '../types';

const BASE_URL = '/api';

export const getDexGasPrice = async (network: ENetwork): Promise<Response<IGasPriceResponse>> => {
  try {
    const response = await axiosToken.get<IBaseResponse<IGasPriceResponse>>(
      `${BASE_URL}/networks/${network}/gas-price`,
    );

    return mapResponse({ data: response.data });
  } catch (error: unknown) {
    return mapError<IGasPriceResponse>({ error });
  }
};
